import React from "react";
import "./Blogs.css";
// Header
import { MainHeaderr } from "../../Components/mainHeader/HeaderMain";
// Components
import { BlogSide } from "../../Components/myBlogComponents/BlogSideBar/BlogSide";
import { AllBlogsContainer } from "../../Components/myBlogComponents/AllBlogsContainer/AllBlogsContainer";
import MainFooter from "../../Components/MainFooter/MainFooter";



export const Blogs = () =>{
    return(
        <div className="BlogsBody" >
            <MainHeaderr />
            <div className="Body d-flex justify-content-between align-items-top">
                <div className="AllBlogsContainer"> <AllBlogsContainer />  </div>
                <div className="BlogSideBar" > <BlogSide /> </div>
            </div>
            <MainFooter />
        </div>
    );
}